import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
interface PianificaLaTuaTutelaProps {
  bgColor?: string;
  fgColor?: string;
}
export default function PianificaLaTuaTutela({
  bgColor,
  fgColor
}: PianificaLaTuaTutelaProps = {}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const sectionStyle = {
    "--section-bg": bgColor || "var(--primary)",
    "--section-fg": fgColor || "var(--primary-foreground)"
  } as React.CSSProperties;
  return;
}